"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PojoMap = void 0;
var PojoMap_1 = require("./PojoMap");
Object.defineProperty(exports, "PojoMap", { enumerable: true, get: function () { return PojoMap_1.PojoMap; } });
